import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ITripPreference } from 'src/app/core/types/interfaces/trip-elements.interface';

@Component({
    selector: 'app-trip-slider',
    templateUrl: './trip-slider.component.html',
    styleUrls: ['./trip-slider.component.scss'],
    imports: [FormsModule]
})
export class TripSliderComponent implements OnChanges, AfterViewInit {
  @Input() preferenceSlider: any;
  @Output() onSliderChange: EventEmitter<ITripPreference> = new EventEmitter();

  disabled: boolean = false;
  private prevSlider: any;

  @ViewChild('fillTrackRef') private fillTrackRef: ElementRef;

  ngOnChanges(changes: SimpleChanges) {
    const { preferenceSlider } = changes;
    if (preferenceSlider && preferenceSlider.currentValue) {
      this.preferenceSlider = preferenceSlider.currentValue;
      this.prevSlider = Object.assign({}, this.preferenceSlider);
      this.setTrackStyles(this.preferenceSlider.value);
    }
  }

  ngAfterViewInit() {
    this.setTrackStyles(this.preferenceSlider.value);
  }

  sliderChange(): void {
    if (this.preferenceSlider.value !== this.prevSlider.value) {
      this.setTrackStyles(this.preferenceSlider.value);

      if (!this.disabled) {
        this.prevSlider = Object.assign({}, this.preferenceSlider);
        this.onSliderChange.emit(this.preferenceSlider);
      }
    }
  }

  public onMouseDown(): void {
    this.disabled = true;
  }

  public onMouseUp(): void {
    this.disabled = false;
    this.sliderChange();
  }

  public onTouchStart() {
    this.onMouseDown();
  }

  public onTouchEnd() {
    this.onMouseUp();
  }

  private setTrackStyles(value: number): void {
    if (this.fillTrackRef && this.fillTrackRef.nativeElement) {
      this.fillTrackRef.nativeElement.style.width = `${value}0%`;
    }
  }
}
